import "./Ingreso.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Ingreso = (props) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const [car, setCar] = useState('');
    const [info, setInfo] = useState([]);

    function logout() {
        localStorage.setItem("login", false);
        localStorage.setItem("loginStatus", "Sesión cerrada exitosamente");
        //navigate("/");
        window.location.href = "https://cootransfusa.com/mantenimiento/"
    }

    useEffect(() => {
        if (car.vehiculo && !car.mensaje) {
            setInfo(Array.from(car.vehiculo));
        }
    }, [car]);

    const onSubmit = (data) => {
        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((response) => {
            setCar(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
    };

    const selectVehiculo = i => {
        let codigo = i.vecodveh
        let placa = i.veplaveh
        let marca = i.manommar
        let modelo = i.vemodveh

        const data = {
            cod: codigo,
            pla: placa,
            mar: marca,
            mod: modelo
        }

        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", props.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((response) => {
            props.handleDataReceived(response.data)
        })
        .catch((error) => {
            console.error(error);
        });
    }

    const regreso = () => {
        const data = {
            sesion: true,
            formato: false,
            ingreso: false
        }
        props.handleDataReceived(props.stringify(data))
    }

    return (
        <>
            <button type="button" onClick={regreso} className="button_back ingreso_button ingreso_button_left"><i class="fa-solid fa-rotate-left" style={{ color: "#ffffff", marginRight: "10px" }}></i>Regresar</button>
            <button type="button" onClick={logout} className="button_logout ingreso_button ingreso_button_right">Cerrar Sesión<i class="fa-solid fa-right-from-bracket" style={{ color: "#ffffff", marginLeft: "10px" }}></i></button>
            <div className="ingreso_content">
                <div className="ingreso">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <span>seleccionar vehículo</span><br /><br />
                        <input type="number" placeholder="Ingrese el número interno" name="interno" required {...register("interno", { required: true })} />
                        <input type="submit" value="Buscar" className="ingreso_submit button_back"/>
                        <p className={ !car.mensaje ? '' : 'ingreso_incorrect' }>{!car.mensaje ? '' : car.mensaje}</p>
                    </form>
                </div>

                <div className="ingreso_tabla">
                {info.length > 0 && (
                        <table>
                            <thead>
                                <tr>
                                    <td>Número</td>
                                    <td>Placa</td>
                                    <td>Marca</td>
                                    <td>Modelo</td>
                                    <td>Seleccionar</td>
                                </tr>
                            </thead>
                            <tbody>
                                {info.map((i) => (
                                    <tr>
                                        <td>{i.vecodveh}</td>
                                        <td>{i.veplaveh}</td>
                                        <td>{i.manommar}</td>
                                        <td>{i.vemodveh}</td>
                                        <td>
                                            <button type="button" onClick={() => selectVehiculo(i)} className="ingreso_seleccionar button_review">Seleccionar</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
}

export default Ingreso;